import {
  baseQuery,
  CREATE_PARTNERS,
  DELETE_PARTNER,
  GET_ALL_PARTNERS,
  UPDATE_PARTNER_STATUS,
  UPDATE_PARTNERS,
} from "@/graphql";
import { createApi } from "@reduxjs/toolkit/query/react";
import { setSpOwnerPartnerData } from "./partner-slice";

export const spOwnerPartnerApi = createApi({
  reducerPath: "api/spOwnerPartner",
  tagTypes: ["spOwnerPartners"],
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getAllSpOwnerPartners: builder.query<
      SPOwnerPartnerResponse,
      { page?: number; limit?: number; searchKeyword?: string; search?: string; tenantId?: string }
    >({
      query: (variables) => ({
        document: GET_ALL_PARTNERS,
        variables: { ...variables },
      }),
      providesTags: ["spOwnerPartners"],
      transformResponse: (response: {
        getAllPartners: SPOwnerPartnerResponse;
      }) => {
        return response?.getAllPartners;
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        dispatch(setSpOwnerPartnerData([]));
        try {
          const { data } = (await queryFulfilled).data;

          dispatch(setSpOwnerPartnerData(data));
        } catch (error) {}
      },
    }),
    postSpOwnerPartner: builder.mutation<
      void,
      Omit<
        SPOwnerPartnerTypes,
        "_id" | "createdAt" | "totalClients" | "status" | "isRestricted"
      >
    >({
      query: (data) => ({
        document: CREATE_PARTNERS,
        variables: { partnerData: data },
      }),
      invalidatesTags: ["spOwnerPartners"],
    }),
    updateSpOwnerPartner: builder.mutation<
      void,
      {
        partnerId: string;
        partnerData: Pick<SPOwnerPartnerTypes, "firstName" | "lastName">;
      }
    >({
      query: (data) => ({
        document: UPDATE_PARTNERS,
        variables: { ...data },
      }),
      invalidatesTags: ["spOwnerPartners"],
    }),
    deleteSpOwnerPartner: builder.mutation<DeleteResponse, { userId: string ,tenantId?:string}>({
      query: (id) => ({
        document: DELETE_PARTNER,
        variables: id,
      }),
      invalidatesTags: ["spOwnerPartners"],
    }),
    updatePartnerStatus: builder.mutation<
      IUpdateUserStatusResponse,
      IUpdateUserStatusRequest
    >({
      query: ({ email, isRestricted }) => ({
        document: UPDATE_PARTNER_STATUS,
        variables: {
          email,
          isRestricted,
        },
      }),
      invalidatesTags: ["spOwnerPartners"],
    }),
  }),
});

export const {
  useGetAllSpOwnerPartnersQuery,
  usePostSpOwnerPartnerMutation,
  useUpdateSpOwnerPartnerMutation,
  useDeleteSpOwnerPartnerMutation,
  useUpdatePartnerStatusMutation,
} = spOwnerPartnerApi;
